<template>
    <!-- 全局顶部欢迎头 -->
    <div class="layout-breadcrumb-container" style='z-index : 9999; margin: 0;padding:0;'>
        <div class="menu-logo">
<!--            <a href="#/project" class="logo">
                <img :src="'layout/images/logo-'+ (colorScheme === 'dark' || colorScheme === 'light_dark' ? 'light' : 'dark') + '.png'">
            </a>-->

            <a href="#/project" class="app-name">
                <img src='../public/layout/images/whiteLogo.png'>
            </a>
        </div>
        <div class="layout-breadcrumb-left-items">
            <a href="javascript:;" class="menu-button" @click="onMenuButtonClick($event)" v-if="isStatic()">
                <i class="pi pi-bars"></i>
            </a>
        </div>
        <div class="layout-breadcrumb-right-items">
            <div  style="margin-right: 10px;padding-right: 30px;height: 45px;margin-top: 4px; border-right: 1px solid white;line-height: 45px;"  @mouseleave="selectedShow=false">
                <div style="margin:5px" >
                    <img src='../public/layout/images/select.png' alt='avatar' style='width: 30px; height: 30px;color : white;padding:2.5px;margin:5px 0' @click="opShow">
                </div>
            </div>
            <div style="position: relative;padding-bottom: 0;" :class="['layout-inline-menu', {'layout-inline-menu-active': activeInlineProfile}]"
                 v-if='!isMobile() && (isStatic() || isSlim() || isSidebar())'>
                <a class='layout-inline-menu-action' style='padding : 0' @click='onChangeActiveInlineMenu'>
                    <img src='../public/layout/images/user.png' alt='avatar' style='width: 44px; height: 44px;color : white'>
                    <span class='layout-inline-menu-text'
                          style="width:7.5rem;font-weight: bold;word-wrap: break-word;white-space: break-spaces; color : white">{{ firstName+" "+lastName }}</span>
                    <i class='layout-inline-menu-icon pi pi-angle-down'></i>
                </a>
                <transition name='layout-inline-menu-action-panel' >
                    <ul v-show='activeInlineProfile' style="position: absolute;top:60px;right:0;padding:0;background:#efeffa" class='layout-inline-menu-action-panel'>
                        <li class="layout-inline-menu-action-item userLi">
                            <el-popover placement="right-end" @before-enter="nameShow" transition="el-zoom-in-top" :width="300"
                                        trigger="hover">
                                <template #reference>
                                    <a>
                                        <i class="pi pi-user pi-fw" style='color : black'></i>
                                        <span class='userInfo' style="width:12rem; ">
                                        <p style="word-wrap: break-word;white-space: break-spaces;color : black">{{micAccountName}}</p>
                                    </span>
                                    </a>
                                </template>
                                <ScrollPanel style="height: 80px; margin-top: 10%" class="custom">
                                    <div v-for="(item,index) in list" :class="['company',index%2==1?'other':'']" :key="index">
                                        <div style="font-weight:bold;margin-bottom:5px;">
                                            <i class="pi pi-bookmark-fill" style='color : black'></i>
                                            {{item.clientName}}
                                        </div>
                                        <div>
                                            <i class="pi pi-id-card" style='color : black'></i>
                                            {{item.title}}
                                        </div>
                                    </div>
                                </ScrollPanel>
                            </el-popover>
                        </li>
                        <li class='layout-inline-menu-action-item userLi' @click='onLogOut'>
                            <a>
                                <i class='pi pi-power-off pi-fw' style='color : black'></i>
                                <span style='color : black'>Logout</span>
                            </a>
                        </li>
                    </ul>
                </transition>
            </div>
        </div>
    </div>
    <OverlayPanel ref="op" :baseZIndex="99999">
        <!-- <Listbox @change="changeSelect" v-model="selectedCity" :modelValue="false" :options="cities" optionLabel="name" style="background: transparent;" class="w-full horizontal-listbox" >
            <template #option="slotProps">
                <div class="icon-text-container" >
                    <img :alt="slotProps.option.name" :src="slotProps.option.imgPath"  style="height:30px;" />
                    <span class="text">{{ slotProps.option.name }}</span>
                </div>
            </template>
        </Listbox> -->
        <el-button @click="changeSelect(item)"
                   style="box-shadow: none;padding:20px;margin:10px"
                   v-for="(item,index) in cities" :key="index" type="primary" link>
            <template #icon>
                <img :alt="item.name" :src="item.imgPath"  style="height:30px;" />
            </template>
            <template #default>
                <span style="margin-left: 10px;">
                    {{ item.name }}
                </span>
            </template>
        </el-button>
    </OverlayPanel>
</template>

<script>
import requests from "@/request";
import homePng from '../public/layout/images/home.png'
import reportPng from '../public/layout/images/report.png'
import router from '@/router';
import OverlayPanel from 'primevue/overlaypanel';
export default {
    components:{
        OverlayPanel,
    },
    props: {
        timeZone: {
            type: String,
            default: ''
        },
        menuMode: String,
        searchActive: {
            type: Boolean,
            default: false
        },
        searchClick: {
            type: Boolean,
            default: false
        },
        workflowsAgentTodo: {
            type: Array,
            default: []
        },
        queryAllWarning: {
            type: Array,
            default: []
        },
        queryAllException: {
            type: Array,
            default: []
        },
        selectOrderChanges: {
            type: Array,
            default: []
        },
        activeInlineProfile: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['menubutton-click', 'rightmenu-button-click', 'update:searchActive', 'update:searchClick','change-inlinemenu'],
    data() {
        return {
            clientName: localStorage.getItem('clientName'),
            title: localStorage.getItem('title'),
            list: [],
            micAccountName: localStorage.getItem('micAccountName'),
            user : localStorage.getItem("micAccountName"),
            sid :  localStorage.getItem("sessionId"),
            items: [],
            search: '',
            userName: localStorage.getItem("userName"),
            firstName: localStorage.getItem('firstName'),
            lastName: localStorage.getItem('lastName'),
            selectedCity: false,
            selectedShow: false,
            queryAllWarningShow: false,
            queryAllExceptionShow: false,
            WorkflowsAgentTodoShow: false,
            cities: [// https://p3-demo.predicine.com/index 测试
                { name: 'Pharma Partner Portal', path: 'https://p3-demo.predicine.com/index?sid='+this.sid+'&loginHint='+this.user, icon: 'pi pi-home',imgPath:homePng },
                { name: 'Report', path: "https://p3-demo.predicine.com/index", icon: 'pi pi-file',imgPath:reportPng},
            ],
            isVisible: true,
            isVisible2: true,
            isVisible3: true,
            isVisible4: true,
            intervalId: null,
            intervalId2: null,
            intervalId3: null,
            intervalId4: null,
            selectOrderChanges1: []
        }
    },
    watch: {
        $route() {
            this.watchRouter();
        },
        'selectOrderChanges': {
            handler: function(val) {
                this.selectOrderChanges1 = val
            },
            deep: true
        }
    },
    created() {
        this.watchRouter();
        this.user = localStorage.getItem("micAccountName");
         this.sid = localStorage.getItem("sessionId");
    },
    beforeDestroy() {
        this.clearFlashing()
    },
    mounted() {
        this.startFlashing2(); // 开始闪烁
    },
    methods: {
        deleteItem(key) {
            //修改单子需要判断单子状态
            requests({
                url: "/system/user/biolims/deleteInform?id=" + key,
                // data: {
                //   id:key,
                // }
            }).then((res) => {
                if (res.data.status == 200) {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t("dashboard.deleteSuccess"),
                        life: 2000
                    });
                    this.selectOrderChanges1.forEach((item, index) => {
                        if (item.key == key) {
                            this.selectOrderChanges1.splice(index, 1)
                        }
                    })
                    this.$parent.socket.close();
                    this.$parent.connectWebSocket();
                } else {
                    this.$toast.add({
                        severity: 'warn',
                        summary: this.$t("dashboard.deleteError"),
                        life: 2000
                    });
                }
            });
        },
        startFlashing2() {
            this.intervalId = setInterval(() => {
                this.isVisible = !this.isVisible; // 切换可见性
            }, 2000); // 每500毫秒切换一次
            this.intervalId2 = setInterval(() => {
                this.isVisible2 = !this.isVisible2; // 切换可见性
            }, 2000); // 每500毫秒切换一次
            this.intervalId3 = setInterval(() => {
                this.isVisible3 = !this.isVisible3; // 切换可见性
            }, 2000); // 每500毫秒切换一次
            this.intervalId4 = setInterval(() => {
                this.isVisible4 = !this.isVisible4; // 切换可见性
            }, 2000); // 每500毫秒切换一次
        },
        clearFlashing() {
            clearInterval(this.intervalId); // 停止闪烁
            clearInterval(this.intervalId2); // 停止闪烁
            clearInterval(this.intervalId3); // 停止闪烁
            clearInterval(this.intervalId4); // 停止闪烁
            this.isVisible = true; // 确保消息显示
            this.isVisible2 = true; // 确保消息显示
            this.isVisible3 = true; // 确保消息显示
            this.isVisible4 = true; // 确保消息显示
        },
        watchRouter() {
            if (this.$router.currentRoute.value.meta.breadcrumb) {
                this.items = [];
                const bc = this.$router.currentRoute.value.meta.breadcrumb[0];
                for (let pro in bc) {
                    this.items.push({ label: bc[pro] });
                }
            }
        },
        onMenuButtonClick(event) {
            this.$emit('menubutton-click', event);
        },
        breadcrumbClick() {
            this.$emit('update:searchActive', true);
            this.$emit('update:searchClick', true);
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        opShow(event){
            this.$refs.op.toggle(event);
        },
        changeSelect(el) {
            this.selectedShow = false
            this.$store.state.showLeftMenu = false
            this.user = localStorage.getItem("micAccountName");
            this.sid = localStorage.getItem("sessionId");
            setTimeout(() => {
                //window.location.href = el.path;
                window.open(el.path,'_blank')
            })
        },
        isMobile() {
            return window.innerWidth <= 991;
        },
        isSlim() {
            return this.menuMode === 'slim';
        },
        isSidebar() {
            return this.menuMode === 'sidebar';
        },
        onChangeActiveInlineMenu(event) {
            this.$emit('change-inlinemenu', event);
            event.preventDefault();
        },
        onLogOut: async function() {
            if (localStorage.getItem('token')) {
                localStorage.removeItem('token');
            }
            if (localStorage.getItem('sessionId')) {
                localStorage.removeItem('sessionId');
            }
            if (localStorage.getItem('userName')) {
                localStorage.removeItem('userName');
            }
            if (localStorage.getItem('language')) {
                localStorage.setItem('language', 'zh_CN');
            }
            if (localStorage.getItem('X-DS')) {
                localStorage.removeItem('X-DS');
            }
            if (localStorage.getItem('router')) {
                localStorage.removeItem('router');
            }
            router.push({
                path: '/'
            });
        },
        nameShow() {
            this.list = []
            let titleList = this.title.split(',')
            let clientNameList = this.clientName.split(',')

            for (let i = 0; i < titleList.length; i++) {
                this.list.push({
                    title: titleList[i],
                    clientName: clientNameList[i]
                })
            }
        },
    },
}
</script>

<style scoped lang='scss'>
.layout-breadcrumb-container{
    background: #4698CB;
    margin-bottom: 20px;
    height : 60px;
}
.layout-breadcrumb-container .menu-logo .app-name img {
    height: 4rem;
    padding-left: 16px;
}
.layout-breadcrumb-container .menu-logo {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -ms-flex-align: center;
    align-items: center;
}

.layout-breadcrumb-container .menu-logo .menu-pin {
    display: none;
    width: 32px;
    height: 32px;
    margin-left: auto;
    border-radius: 6px;
    -moz-transition: all 0.2s;
    -o-transition: all 0.2s;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}

.layout-breadcrumb-container .menu-logo .menu-pin>span {
    font-size: 1.25rem;
}

.layout-breadcrumb-container .menu-logo .logo img {
    height: 2.5rem;
    border: 0 none;
}

.message {
    transition: opacity .5s;
}

:deep(.p-breadcrumb > ul > li.p-breadcrumb-chevron:first-of-type) {
    display: none;
}

.lh33 {
    line-height: 33px;
}

.layout-breadcrumb-container {
    padding-top: 10px;
}

.selectedDown {
    right: 200px;
    position: absolute;
    z-index: 999;
    background: #fff;
    top: 50px;
}

.selectedDownIcon {
    position: absolute;
    right: -207px;
    top: 30px;
    position: absolute;
    z-index: 999;
    background: #fff;
}

.dataClass {
    width: 400px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    div {
        width: 32%;
        text-align: center;
        line-height: 30px;
    }
}

.dataClassHove {
    &:hover {
        background: #f9f9f9;
        color: #4ab6f9;
        cursor: pointer;
    }
}

.prompt {
    // box-sizing: border-box;
    // padding-left:25px;
    // text-align: left;
    // width:95%;
    // line-height: 40px;
    margin-bottom: 15px;
    // border-radius: 25px;
    // margin-left: 20px;
    // padding-right: 15px;
}

/* 横向排列核心代码 */
.horizontal-listbox :deep(.p-listbox-list) {
    display: flex;
    flex-direction: row;
    gap: 1rem; /* 选项间距 */
    overflow-x: auto; /* 允许横向滚动 */
    padding: 0.5rem; /* 留出滚动空间 */
}

.horizontal-listbox :deep(.p-listbox-item) {
    flex-shrink: 0; /* 防止选项挤压 */
    padding: 0.5rem 1rem !important; /* 调整内边距 */
}

/* 图标文字水平排列 */
.icon-text-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap; /* 防止文字换行 */
}
ul{
    padding: 0;
    margin: 0;
    list-style-type: none;
    li{
        padding:0;
        margin:0;
        padding-top: 10px;
        border-bottom:1px solid rgba(0, 0, 0, 0.1)
    }
    li:last-child{
        border: none;
    } 
}
</style>


<style>
.custom .p-scrollpanel-wrapper {
    border-right: 9px solid #f4f4f4;
}

.custom .p-scrollpanel-bar {
    background-color: #1976d2;
    opacity: 1;
    transition: background-color .3s;
}

.p-scrollpanel-bar-x {
    display: none;
}

.custom .p-scrollpanel-bar:hover {
    background-color: #135ba1;
}

.link-like {
    color: #007bff; /* 蓝色文字 */
    text-decoration: underline; /* 下划线 */
    cursor: pointer; /* 光标样式 */
    transition: color 0.3s ease; /* 颜色渐变 */
}

.link-like:hover {
    color: #0056b3; /* 悬停时的颜色 */
    text-decoration: underline; /* 保持下划线 */
}

.link-like:active {
    color: #003d7a; /* 点击时的颜色 */
}

.icon-text-container {
    display: flex;
    flex-direction: column;  /* 垂直排列 */
    align-items: center;    /* 水平居中（可选） */
    gap: 4px;              /* 图标和文字的间距 */
}

.icon-list {
    display: flex;          /* 横向排列 */
    gap: 20px;              /* 图标之间的间距 */
    justify-content: center; /* 水平居中（可选） */
}
</style>
